import { RotateCcw } from "lucide-react";

const GuaranteeBadge = ({ neutral = false, testid = "guarantee-badge", className = "" }) => (
    <span
        data-testid={testid}
        className={`inline-flex items-center gap-2 rounded-full border px-5 py-2.5 text-xs font-bold uppercase tracking-[0.15em] ${
            neutral ? "border-black/10 bg-white text-slate-600 shadow-sm" : "border-brand/30 bg-brand/5 text-brand"
        } ${className}`}
    >
        <RotateCcw className={`h-4 w-4 ${neutral ? "text-brand" : ""}`} />
        Garantie : repassage gratuit sous 30 jours
    </span>
);

export default GuaranteeBadge;
